import { Consumer } from '../../store/profile/types';
import { isValidEmail } from '../../modules/utils/EmailUtils';
import { ConsumerSharedUiData } from '../../store/consumerPreferences/types';

export function showEmailAlert(profile?: Consumer, sharedUiData?: ConsumerSharedUiData): boolean {
  const emailObj = profile?.emails?.[0];
  const value = emailObj?.value;
  const isValid = isValidEmail(value);
  const lastSeen = sharedUiData?.lastSeenUpdateEmail;
  const now = Date.now();
  const hasSeenUpdateEmail = lastSeen && now - lastSeen < 1000 * 60 * 60 * 24;

  return !isValid && !hasSeenUpdateEmail;
}
